import config from '@config';
import merge from 'lodash/merge';

const fontFamily = 'var(--FedraSansStd-medium)';

const commonLangStyle = ({ lang, ...props }) => {
  const isIndian = config.indianLang.indexOf(lang) > -1;
  const styleObj = {
    highLightContent: {
      fontFamily: isIndian
        ? config.isoLangFontApp[lang]
        : 'var(--FedraSansStd-book)',
      fontSize: { base: '16px', md: '18px' },
      lineHeight: { base: '24px', md: '26px' },
      textAlign: isIndian ? config.isoLangFontApp[lang] : 'center',
    },
    benefitsGroup: {
      fontFamily: isIndian
        ? config.isoLangFontApp[lang]
        : 'var(--FedraSansStd-book)',
      fontSize: { base: '16px', md: '18px' },
      lineHeight: '26px',
      textAlign: isIndian ? config.isoLangFontApp[lang] : 'center',
    },
  };

  const finalObj = merge(styleObj, { ...props });
  return finalObj;
};

const CompWithLeastStyle = {
  en: commonLangStyle({ lang: 'en' }),
  // bn: commonLangStyle({ lang: 'bn' }),
  // hi: commonLangStyle({
  //   lang: 'hi',
  // }),
  // te: commonLangStyle({ lang: 'te' }),
  // kn: commonLangStyle({ lang: 'kn' }),
  // gu: commonLangStyle({ lang: 'gu' }),
  // mr: commonLangStyle({ lang: 'mr' }),
  // ml: commonLangStyle({ lang: 'ml' }),
  // 'zh-tw': commonLangStyle({ lang: 'zh-tw' }),
  // zh: commonLangStyle({ lang: 'zh' }),
  // it: commonLangStyle({ lang: 'it' }),
  // fr: commonLangStyle({ lang: 'fr' }),
  // de: commonLangStyle({ lang: 'de' }),
  // es: commonLangStyle({ lang: 'es' }),
  // ru: commonLangStyle({ lang: 'ru' }),
  // ta: commonLangStyle({ lang: 'ta' }),
  // cn: commonLangStyle({ lang: 'cn' }),
  // ar: commonLangStyle({
  //   lang: 'ar',
  // }),
  // id: commonLangStyle({ lang: 'id' }),
};
export default CompWithLeastStyle;
